import { render, staticRenderFns } from "./ShowSpinners.vue?vue&type=template&id=c0cc52de&scoped=true"
import script from "./ShowSpinners.vue?vue&type=script&lang=ts"
export * from "./ShowSpinners.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cc52de",
  null
  
)

export default component.exports